import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { KeycloakService } from './keycloak.service';

@Injectable({
	providedIn: 'root',
})
export class JWTAuthGuard implements CanActivate {
	private readonly keycloak = inject(KeycloakService);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
		return this.isAccessAllowed(route, state);
	}

	public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const isLoggedIn = this.keycloak.isLoggedIn();
		if (!isLoggedIn) {
			// login() redirects the browser to Keycloak — the current code path is aborted.
			// After successful login, the user is redirected back via redirectUri and the guard runs again.
			// The return false is a safety-net in case login() resolves without redirect (e.g. popup mode).
			await this.keycloak.login({
				redirectUri: globalThis.location.origin + state.url,
			});
			return false;
		}

		return true;
	}

	canActivate2(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return true;
	}
}
